import React from 'react';

import PropTypes from 'prop-types';

import {
  DownArrowIcon,
  UpArrowIcon,
  VodacomRedLogo
} from 'src/Components/Common';

import {
  cardKeyMobile
} from 'src/Common/constants';

import './TopPicks.css';

const formatNumber = (number, decimalPlaces = 2) => {
  
  number = parseFloat(number);

  if (Number.isInteger(number)) {

    return number.toString();

  } else {

    if (Math.abs(number - Math.round(number)) < Number.EPSILON) {
      return Math.round(number).toString();
    } else {
      return number.toFixed(decimalPlaces);
    }
  }
}

const TopPicks = (props) => {

  return (
    <div className='card-main-mobile-container'
      onClick={props.selectPackage}>

      <div
        className={`card-main-mobile-promotion-container ${
          props.cardKey === 'mostPopular'  ? 'special' : 'default'
        }`}
      >
        {cardKeyMobile[props.cardKey]}
      </div>

      <div className='card-main-mobile-details-container'>

        <div className="card-provider-logo-mobile">
          <VodacomRedLogo />
        </div>

        <div className="card-price-mobile-container">
          <div className='card-price-mobile-text'>
            From
          </div>
          <div className={`card-price-mobile ${ props.cardKey === 'mostPopular'  ? 'special-text' : '' }`}>
            {`R${ formatNumber(props.price) } PM`}</div>
          <div className={`card-price-mobile-text ${ props.cardKey === 'mostPopular'  ? 'special-text' : '' }`} >
            {props.duration  === 'Month to Month' ? 'month-to-month' : `x ${ props.duration.toLowerCase() }` }
          </div>
        </div>
        {props.promotion && props.originalPrice && <div className='mobile-card-original-price'>{`R${ parseFloat(props.originalPrice).toFixed() } PM`}</div>}

        <div className="card-speed-mobile-wrapper">

          <div className='top-pick-speed-wrapper'>
            <div className="and-symbol-wrapper">
              <DownArrowIcon />
            </div>

            <div className="speed-value">
              {props.downloadSpeed}
            </div>
          </div>

          <div className='top-pick-speed-wrapper'>
            <div className="and-symbol-wrapper">
              <UpArrowIcon />
            </div>

            <div className="speed-value">
              {props.uploadSpeed}
            </div>
          </div>
        </div>

      </div>
    </div>

  );
};

TopPicks.propTypes = {
  selectPackage: PropTypes.func,
  providerLogo: PropTypes.string,
  promotion: PropTypes.bool,
  price: PropTypes.string,
  originalPrice: PropTypes.string,
  duration: PropTypes.string,
  downloadSpeed: PropTypes.string,
  uploadSpeed: PropTypes.string,
  width: PropTypes.string,
  cardKey: PropTypes.string.isRequired
};

export default TopPicks;
